import React, { Component } from 'react';
import { connect } from 'react-redux';

import { completeAndUpdateTour } from 'actions/feature-tour';
import {
  SHARE_WITH_LOOM_TEAM_COMPLETE,
  SHARE_WITH_LOOM_TEAM_OPT_IN,
} from 'constants/feature-tour';
import { EXPERIMENT_SHARE_WITH_LOOM_TEAM } from 'constants/featureFlag';
import { getFeatureFlagCreator } from 'creators/featureFlag';
import {
  onCancelShareLoomForm,
  showShareLoomForm,
} from 'utilities/share-loom-exp';

import closeIconSrc from 'img/icons/new/close-dg.svg';
import emailIconSrc from 'img/illustrations/mail.svg';

import './styles.less';

class ShareLoomTeamCTA extends Component {
  state = {
    show: true,
  };

  onCloseClick = () => {
    onCancelShareLoomForm();

    this.setState({ show: false });
  };

  componentDidMount() {
    this.props.getFeatureFlag(EXPERIMENT_SHARE_WITH_LOOM_TEAM);
  }

  render() {
    const { show } = this.state;
    const { wantsToShareWithLoomTeam } = this.props;

    return (
      <>
        {show && wantsToShareWithLoomTeam ? (
          <div className="share-loom-team-group">
            <a className="main-click-group" onClick={showShareLoomForm}>
              <img src={emailIconSrc} />
              <span>Send your first Loom to us!</span>
            </a>
            <a className="close-wrapper" onClick={this.onCloseClick}>
              <img src={closeIconSrc} className="close-btn" />
            </a>
          </div>
        ) : null}
      </>
    );
  }
}

const mapStateToProps = state => {
  const { user, share_video, feature_flags: featureFlags } = state;

  const userLoggedIn = Boolean(window.loomSSRUser);
  const userOwnsVideo = share_video.current_user_is_owner;

  const shareFirstVideoFlag =
    featureFlags[EXPERIMENT_SHARE_WITH_LOOM_TEAM] || {};

  const isInShareExp =
    shareFirstVideoFlag.value === 'show' &&
    user.current.onboarding[SHARE_WITH_LOOM_TEAM_OPT_IN] &&
    !user.current.onboarding[SHARE_WITH_LOOM_TEAM_COMPLETE];

  const wantsToShareWithLoomTeam =
    userLoggedIn && userOwnsVideo && isInShareExp;

  return {
    wantsToShareWithLoomTeam,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getFeatureFlag: featureFlag => dispatch(getFeatureFlagCreator(featureFlag)),
    setShareWithLoomComplete: () =>
      dispatch(completeAndUpdateTour(SHARE_WITH_LOOM_TEAM_COMPLETE)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareLoomTeamCTA);
